exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.warns dt i {\n  font-size: 3.2vw;\n  margin-right: 1.06667vw;\n  vertical-align: middle;\n}\n.warns dt span {\n  vertical-align: middle;\n}\n.warns dd {\n  margin-left: 4.26667vw;\n  margin-top: 0.8vw;\n}\n", "", {"version":3,"sources":["F:/develop/JCeshop-wx/src/components/warns/index.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;CACxB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,uBAAuB;EACvB,kBAAkB;CACnB","file":"index.vue","sourcesContent":["\n.warns dt i {\n  font-size: 3.2vw;\n  margin-right: 1.06667vw;\n  vertical-align: middle;\n}\n.warns dt span {\n  vertical-align: middle;\n}\n.warns dd {\n  margin-left: 4.26667vw;\n  margin-top: 0.8vw;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8999e88","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.1.0@sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/warns/index.vue
// module id = V0P+
// module chunks = 83